import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import {
  LandmineOpenCreate,
  LandmineOpensController,
} from '../controllers/LandmineOpensController';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import CrudActionContainer from './CrudActionContainer';

class LandmineOpensCRUDActions extends CrudActionContainer {
  constructor() {
    super('LANDMINE_OPENS');
  }

  create(entity: LandmineOpenCreate) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        const res = await LandmineOpensController.postLandmineOpen(entity);
        return res.entity;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  update(id: number, billingOpened: boolean) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        const res = await LandmineOpensController.putLandmineOpen(
          id,
          billingOpened,
        );
        return res.entity;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }
}

export const landmineOpensCRUDActions = new LandmineOpensCRUDActions();

export const useLandmineOpensCRUDActions = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  return useMemo(
    () => ({
      create: (entity: LandmineOpenCreate) =>
        dispatch(landmineOpensCRUDActions.create(entity)),
      update: (id: number, billingOpened: boolean) =>
        dispatch(landmineOpensCRUDActions.update(id, billingOpened)),
    }),
    [dispatch],
  );
};
